// src/components/studentPortal/TalentShowcase.jsx
// Section 5 of the Student Portal. UI SHELL ONLY - static mock data below,
// no backend, no payment/monetization logic of any kind.
import React from 'react';
import { FiStar } from 'react-icons/fi';

const MOCK_STUDENTS = [
  { id: 1, name: 'Aisha Rahman', tagline: 'Cinematographer & colorist', featured: true },
  { id: 2, name: 'Rohan Mehta', tagline: 'Documentary editor', featured: false },
  { id: 3, name: 'Priya Nair', tagline: 'Director, short-form drama', featured: false },
  { id: 4, name: 'Karan Desai', tagline: 'Sound design & mixing', featured: false },
  { id: 5, name: 'Meera Iyer', tagline: 'Screenwriter, indie features', featured: false },
  { id: 6, name: 'Vikram Singh', tagline: 'VFX & motion graphics', featured: false },
];

const ShowcaseCard = ({ student }) => (
  <div className="relative rounded-2xl border border-slate-200 bg-white overflow-hidden hover:shadow-md hover:border-teal-300 transition-all duration-200">
    {student.featured && (
      <span className="absolute top-3 right-3 z-10 flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wide text-white bg-gradient-to-r from-teal-500 to-cyan-500 px-2.5 py-1 rounded-full">
        <FiStar size={10} /> Featured
      </span>
    )}
    <div className="h-28 bg-gradient-to-br from-teal-100 to-cyan-100" />
    <div className="p-4">
      <div className="flex items-center gap-2 mb-1">
        <h4 className="font-semibold text-slate-800 truncate">{student.name}</h4>
        <span className="text-[10px] font-medium uppercase tracking-wide text-teal-700 bg-teal-50 px-1.5 py-0.5 rounded-full flex-shrink-0">
          Student
        </span>
      </div>
      <p className="text-xs text-slate-500 mb-3">{student.tagline}</p>
      <button className="text-xs font-medium text-teal-600 hover:text-teal-700">
        View profile →
      </button>
    </div>
  </div>
);

const TalentShowcase = () => (
  <div>
    <h2 className="text-xl font-bold text-slate-800 mb-4">Talent Showcase</h2>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {MOCK_STUDENTS.map((s) => <ShowcaseCard key={s.id} student={s} />)}
    </div>
  </div>
);

export default TalentShowcase;
